// "Zuletzt geöffnet" im Konto (Runde 4, Agent 4A, S02): crm/API.md, Abschnitt 19.4.
// Bis Agent 4A die Oberfläche umstellt, merkt `web/src/daten/zuletzt.ts` weiter im Browser.
import { http } from "./client";

export interface ZuletztEintrag {
  lead_id: string;
  name: string;
  status_label: string | null;
  contact_id: string | null;
  /** zuletzt angesehener Kontakt, für den grauen Untertitel */
  contact_name: string | null;
  geoeffnet_at: string;
}

export const zuletztApi = {
  liste: (limit = 8) => http.get<{ data: ZuletztEintrag[] }>("/api/zuletzt", { limit }),
  merken: (leadId: string, contactId?: string | null) => http.put<void>(`/api/zuletzt/${encodeURIComponent(leadId)}`, contactId ? { contact_id: contactId } : {}),
};
